import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewChild,
  TemplateRef
} from "@angular/core";
import { UtenteVO } from "@app/shared/vo/utenteVO";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { ProfiliService } from "@app/shared/services/profili.service";
import { VisibilitaAttoVO } from "@app/shared/vo/visibilita-attoVO";

@Component({
  selector: "app-modale-visibilita-atto",
  templateUrl: "./modale-visibilita-atto.component.html"
})
export class ModaleVisibilitaAttoComponent implements OnInit {
  @Output()
  changeVisibilita: EventEmitter<VisibilitaAttoVO[]> = new EventEmitter<VisibilitaAttoVO[]>();
  messages = {
    emptyMessage: "Nessun risultato",
    totalMessage: "in totale"
  };

  assegnati: UtenteVO[] = new Array<UtenteVO>();
  nonAssegnati: UtenteVO[] = new Array<UtenteVO>();
  public modalRef: BsModalRef;
  redattoriList: UtenteVO[] = [];
  redattoriListCopia: UtenteVO[];
  private config = {
    class: "modal-dialog modal-info modal-xlg",
    animated: true
  };
  @ViewChild("templateModaleVisibilitaRedattori", { static: false })
  public redattoriModal: TemplateRef<any>;
  // firmatariList: UtenteVO[] = new Array<UtenteVO>();
  redattoreSelezionato: UtenteVO = new UtenteVO();
  listaVisibilita: VisibilitaAttoVO[];
  utente: UtenteVO;

  constructor(
    private profiliService: ProfiliService,
    private modalService: BsModalService
  ) { }

  ngOnInit() { }


  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.redattoriListCopia.filter(function (d) {
      return d.username.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.redattoriList = temp;
    // Whenever the filter changes, always go back to the first page
    //   this.table.offset = 0;
  }

  public openModal(selezionati: VisibilitaAttoVO[], cmuAtto: string, utente?: UtenteVO) {
    this.utente = utente;
    this.redattoriList = new Array<UtenteVO>();
    this.redattoreSelezionato = new UtenteVO();
    this.listaVisibilita = selezionati;
    this.getRedattori(selezionati);
  }

  private async getRedattori(selezionati: VisibilitaAttoVO[]) {
    let utentiRedattori: UtenteVO[] = await this.profiliService
      .getUtentiRedattoriAtto(null)
      .toPromise();
    // const utentiRedattoriSettore: UtenteVO[] = await this.profiliService
    //   .getUtentiRedattoriAtto(cmuAtto)
    //   .toPromise();
    // rimuovi i redattori del mio settore
    // utentiRedattori = utentiRedattori.filter(redattoreGlobal => utentiRedattoriSettore.findIndex(redattoreSettore => redattoreGlobal.id == redattoreSettore.id) == -1);
    const cfSelezionati = selezionati.map(e => e.operatore.id);
    for (let index = 0; index < utentiRedattori.length; index++) {
      if (cfSelezionati.includes(utentiRedattori[index].id)) {
        utentiRedattori[index].check = true;
      }
    }
    this.redattoriList = utentiRedattori;
    this.redattoriListCopia = this.redattoriList;
    this.modalRef = this.modalService.show(this.redattoriModal, this.config);
  }

  seleziona() {
    console.log("seleziona: ", JSON.stringify(this.redattoreSelezionato));

    this.changeVisibilita.emit(this.listaVisibilita);
    this.modalRef.hide();
  }

  private selezione(e, redattore: UtenteVO) {

    this.redattoreSelezionato = redattore;
    this.gestisciVisibilita(e.target.checked, redattore);

    console.log("selezioneTrue end", this.redattoreSelezionato);
  }

  gestisciVisibilita(checked: boolean, redattore: UtenteVO) {
    if (checked == true) {
      //verifico che non sia in listaVisibilità
      let nuovaVisibilia: VisibilitaAttoVO = new VisibilitaAttoVO;
      nuovaVisibilia.utente = redattore;
      nuovaVisibilia.dataInizioVisibilita = new Date().toISOString();
      nuovaVisibilia.utente = this.utente;
      nuovaVisibilia.operatore = redattore;
      this.listaVisibilita.push(nuovaVisibilia);
    } else if (checked == false) {
      this.listaVisibilita = this.listaVisibilita.filter(res => res.operatore.id !== redattore.id);
    }

  }


}
